/* global Waypoint */
import initCount from './count';
require('waypoints/lib/noframework.waypoints.min');

export const TriggerAnimation = (index, el, offset = '60%') => {
    new Waypoint({
        element: el,
        handler: function() {
            initCount();
        },
        offset: offset,
    })
};
